var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-header',{attrs:{"title":_vm.$t('k8s.text_330')}}),_c('page-body',[_c('k8s-rbac-role-list',{attrs:{"id":_vm.listId,"getParams":_vm.getParams}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }